export default {
  customers: {
    title: 'Ügyfelek',
    total: 'Összes',
    search: 'Keresés...',
    filters: 'Szűrők',
    import: 'Importálás',
    importTitle: 'Ügyfelek importálása',
    importDescription: 'Importálja az ügyfeleket az Excel fájlból',
    export: 'Exportálás',
    exportTitle: 'Ügyfelek exportálása',
    exportDescription: 'Exportálja az ügyfeleket az Excel fájlból',
    resetAll: 'Szűrők törlése',
    status: {
      all: 'Státusz',
      new: 'Új partner',
      active: 'Aktív',
      inactive: 'Inaktív',
      unknown: 'Ismeretlen státusz'
    },
    kyc: {
      all: 'Mind',
      verified: 'Ellenőrzött',
      unverified: 'Ellenőrizetlen'
    },
    details: {
      general: 'Általános Információk',
      referredBy: 'Ajánló',
      noReferrer: 'Nincs ajánló',
      loading: 'Betöltés...',
      // ... többi fordítás
    },
    deleteSuccess: "Az ügyfél sikeresen törölve",
    deleteError: "Hiba történt az ügyfél törlésekor",
    deleteConfirmTitle: "Ügyfél törlése",
    deleteConfirmMessage: "Biztosan törölni szeretné a következő ügyfelet: ${name}?",
    unknownCustomer: "Ismeretlen ügyfél",
    noResults: "Nincs találat a keresési feltételekre.",
    referral: 'Meghívott ügyfél',
    groups: {
      title: 'Felhasználói Csoportok',
      new: 'Új csoport',
      edit: 'Csoport szerkesztése',
      delete: 'Csoport törlése',
      name: 'Csoport neve',
      description: 'Leírás',
      filters: {
        title: 'Automatikus szűrők',
        status: {
          label: 'Státusz',
          new: 'Új ügyfelek',
          active: 'Aktív ügyfelek',
          inactive: 'Inaktív ügyfelek',
          all: 'Összes ügyfél'
        },
        registrationDate: {
          from: 'Regisztráció dátuma (ettől)',
          to: 'Regisztráció dátuma (eddig)'
        }
      },
      city: 'Város',
      country: 'Ország',
      createSuccess: 'Új csoport sikeresen létrehozva',
      updateSuccess: 'Csoport sikeresen frissítve',
      deleteSuccess: 'Csoport sikeresen törölve',
      createError: 'Hiba történt a csoport létrehozásakor',
      updateError: 'Hiba történt a csoport frissítésekor',
      deleteError: 'Hiba történt a csoport törlésekor',
      loadError: 'Hiba történt a csoportok betöltésekor',
      users: {
        title: 'Felhasználók manuális hozzáadása',
        search: 'Felhasználó keresése...',
        selected: 'Kiválasztott felhasználók',
        noResults: 'Nincs találat'
      }
    },
    email: {
      title: 'Email Küldés',
      description: 'Küldjön emailt a felhasználóknak',
      templates: {
        title: 'Email Sablonok',
        new: 'Új sablon',
        edit: 'Sablon szerkesztése',
        name: 'Sablon neve',
        subject: 'Tárgy',
        content: 'Tartalom',
        category: {
          label: 'Kategória',
          general: 'Általános',
          welcome: 'Üdvözlő',
          notification: 'Értesítés',
          reminder: 'Emlékeztető',
          marketing: 'Marketing'
        },
        variables: {
          title: 'Elérhető változók',
          name: 'Ügyfél neve',
          email: 'Email cím',
          company: 'Cég neve',
          date: 'Dátum'
        },
        createSuccess: 'Új sablon sikeresen létrehozva',
        updateSuccess: 'Sablon sikeresen frissítve',
        deleteSuccess: 'Sablon sikeresen törölve',
        createError: 'Hiba történt a sablon létrehozásakor',
        updateError: 'Hiba történt a sablon frissítésekor',
        deleteError: 'Hiba történt a sablon törlésekor',
        loadError: 'Hiba történt a sablonok betöltésekor'
      },
      send: {
        title: 'Email küldése',
        recipients: 'Címzettek',
        subject: 'Tárgy',
        message: 'Üzenet',
        sendButton: 'Küldés',
        success: 'Email sikeresen elküldve',
        error: 'Hiba történt az email küldése során',
        limits: {
          title: 'Email küldési korlátozások',
          description: 'A rendszer Google Workspace-t használ az emailek küldéséhez, ezért kérjük vegye figyelembe:',
          daily: 'Napi küldési limit: 2000 email/nap',
          perMinute: 'Percenkénti limit: 60 email/perc'
        }
      }
    }
  },
  customerDetails: {
    title: 'Ügyfél Részletek',
    tabs: {
      information: 'Információk',
      investments: 'Befektetések',
      earnings: 'Bevételek',
      transactions: 'Tranzakciók',
      referral: 'Ajánlói Fa',
      referralEdit: 'Ajánló Módosítása',
      tickets: 'Jegyek'
    },
    basicInfo: {
      title: 'Alapadatok',
      username: 'Felhasználónév',
      email: 'Email',
      country: 'Ország',
      status: 'Státusz',
      createdAt: 'Létrehozva',
      migratedAt: 'Migrálva',
      migratedFrom: 'Migrálva innen'
    },
    financialInfo: {
      title: 'Pénzügyi Információk',
      accountBalance: 'Számlaegyenleg',
      totalProfit: 'Összes Profit',
      totalDeposit: 'Összes Befizetés',
      totalInvestment: 'Összes Befektetés',
      activePlans: 'Aktív Tervek',
      features: {
        deposits: 'Befizetések',
        withdrawals: 'Kifizetések',
        transfers: 'Átutalások'
      }
    },
    transactions: {
      title: 'Tranzakció Történet',
      date: 'Dátum',
      type: 'Típus',
      amount: 'Összeg',
      method: 'Módszer',
      status: 'Státusz',
      id: 'Azonosító'
    },
    referral: {
      title: 'Ajánlói Hálózat',
      stats: {
        total: 'Összes Ajánlott',
        active: 'Aktív Ajánlottak',
        volume: 'Teljes Volumen'
      }
    },
    investments: {
      totalInvested: 'Összes Befektetés',
      activeInvestments: 'Aktív Befektetések',
      totalProfit: 'Összes Profit',
      plan: 'Befektetési Terv',
      amount: 'Összeg',
      profit: 'Profit',
      startDate: 'Kezdés Dátuma',
      endDate: 'Lejárat Dátuma',
      status: 'Státusz'
    },
    earnings: {
      totalEarnings: 'Összes Bevétel',
      thisMonth: 'Ebben a Hónapban',
      lastPayout: 'Utolsó Kifizetés',
      byType: 'Bevételek Típus Szerint',
      date: 'Dátum',
      type: 'Típus',
      amount: 'Összeg',
      status: 'Státusz'
    },
    updateSuccess: 'Ügyfél adatai sikeresen frissítve',
    updateError: 'Nem sikerült frissíteni az ügyfél adatait',
    tickets: {
      title: 'Jegyek',
      total: 'Összes Jegy',
      open: 'Nyitott Jegyek',
      avgResponseTime: 'Átlagos Válaszidő',
      table: {
        id: 'Jegy Azonosító',
        subject: 'Tárgy',
        department: 'Részleg',
        priority: 'Prioritás',
        status: 'Státusz',
        lastUpdate: 'Utolsó Frissítés'
      },
      priority: {
        low: 'Alacsony',
        normal: 'Normál',
        high: 'Magas'
      },
      department: {
        support: 'Általános Támogatás',
        technical: 'Technikai Támogatás',
        billing: 'Számlázás'
      },
      status: {
        open: 'Nyitott',
        pending: 'Függőben',
        closed: 'Lezárt'
      },
      noTickets: 'Nincsenek jegyek',
      createNew: 'Új Jegy Létrehozása'
    },
    quickActions: {
      sendEmail: 'Email Küldése',
      newTicket: 'Új Jegy',
      more: 'További Műveletek',
      exportPDF: 'PDF Exportálása'
    }
  },
  navbar: {
    beta: 'Ez egy béta környezet. Az adatok és funkciók tesztelés alatt állnak.',
    menu: {
      dashboard: 'Vezérlőpult',
      projects: {
        title: 'Projektek',
        all: 'Összes projekt',
        archived: 'Archivált',
        deleted: 'Törölt'
      },
      customers: {
        title: 'Ügyfelek',
        all: 'Összes ügyfél',
        groups: 'Felhasználói csoportok',
        email: 'Email küldés',
        notifications: 'Értesítések',
        referrals: 'Ajánlók',
        referralTree: 'Ajánlói fa'
      },
      discounts: {
        title: 'Kedvezmények',
        all: 'Összes kedvezmény',
        categories: 'Kategóriák kezelése'
      },
      system: {
        title: 'Rendszer',
        pages: 'Oldalak',
        emailTemplates: 'Email sablonok',
        smsTemplates: 'SMS sablonok',
        pushNotifications: 'Push értesítések',
        subscribers: 'Feliratkozók',
        customCss: 'Egyedi CSS',
        clearCache: 'Gyorsítótár törlése',
        appInfo: 'Alkalmazás infó',
        landingPage: 'Kezdőoldal',
        logs: 'Rendszernapló',
        admins: 'Rendszeradminok'
      },
      staff: {
        title: 'Személyzet',
        roles: 'Szerepkörök'
      },
      wallet: {
        title: 'Wallet',
        all: 'Felhasználók',
        transactions: 'Tranzakciók',
        transfers: 'Utalások'
      }
    }
  },
  dashboard: {
    title: 'Vezérlőpult',
    subtitle: 'A platform teljesítményének és fő mutatóinak áttekintése',
    stats: {
      totalCustomers: 'Összes Ügyfél',
      activeCustomers: 'Aktív Ügyfelek',
      totalVolume: 'Teljes Volumen',
      totalInvestments: 'Összes Befektetés',
      pendingKyc: 'Függő KYC',
      openTickets: 'Nyitott Jegyek',
      fromLastMonth: 'az előző hónaphoz képest'
    },
    quickActions: {
      title: 'Gyors Műveletek',
      manageCustomers: 'Ügyfelek Kezelése',
      reviewKyc: 'KYC Ellenőrzés',
      viewInvestments: 'Befektetések',
      supportTickets: 'Support Jegyek'
    },
    availableDiscounts: 'Elérhető kedvezmények',
    noDiscounts: 'Jelenleg nincsenek elérhető kedvezmények',
    checkBackLater: 'Nézz vissza később az új kedvezményekért',
    welcome: 'Üdvözöljük az Előny Klubban!',
    discountInfo: 'Ez egy olyan klub, ahol mindenki talál olyan előnyt, ami megdobogtatja a szívét, könnyebbséget jelent a hétköznapi költségek viselésében, mérsékli a kiadásokat. elérhetővé teszi azt, ami eddig csak álom volt.',
    benefits: {
      exclusive: 'Exkluzív kedvezmények csak klubtagoknak',
      verified: 'Ellenőrzött partnerek és megbízható ajánlatok',
      updated: 'Folyamatosan frissülő kedvezmények és új lehetőségek'
    }
  },
  common: {
    cancel: 'Mégsem',
    save: 'Mentés',
    delete: 'Törlés',
    edit: 'Szerkesztés',
    back: 'Vissza',
    next: 'Következő',
    submit: 'Küldés',
    loading: 'Betöltés...',
    error: 'Hiba',
    success: 'Sikeres',
    confirm: 'Megerősítés',
    yes: 'Igen',
    no: 'Nem',
    search: 'Ügyfelek keresése...',
    showing: 'Megjelenítve',
    of: '/',
    copied: 'Másolva!',
    create: 'Létrehozás',
    confirmBatchOperation: 'Biztosan végrehajtja a műveletet {{count}} elemen?',
    batchOperationSuccess: '{{count}} elem sikeresen módosítva',
    batchOperationError: 'Hiba történt a csoportos művelet során',
    itemsSelected: 'elem kiválasztva',
    activate: 'Aktiválás',
    deactivate: 'Deaktiválás',
    delete: 'Törlés'
  },
  referralManager: {
    title: 'Ajánlói Kezelő',
    subtitle: 'Ügyfelek ajánlói kapcsolatainak kezelése',
    currentReferrer: 'Jelenlegi Ajánló',
    updateReferrer: 'Ajánló Módosítása',
    selectReferrer: 'Új ajánló választása',
    noReferrer: 'Nincs ajánló',
    totalCustomers: 'Összes Ügyfél',
    withReferrer: 'Ajánlóval Rendelkezők',
    noOptions: 'Nincs találat',
    updateSuccess: 'Ajánló módosítva: {{username}} → {{referrer}}',
    updateError: 'Nem sikerült frissíteni az ajánlót',
    treeEditor: 'Ajánlói Fa Szerkesztő',
    treeEditorSubtitle: 'Ajánlói kapcsolatok szerkesztése szöveges formában',
    treeStructure: 'Fa Szerkezet',
    treeInstructions: 'Használj szóközöket a gyermek kapcsolatok behúzásához. Formtum: felhasználónév (ID: szám)',
    resetTree: 'Fa Visszaállítása',
    invalidFormat: 'Érvénytelen formátum a sorban: {{line}}',
    duplicateId: 'Duplikált ID található: {{id}}',
    fetchError: 'Nem sikerült betölteni az ügyfeleket',
    dragDropInstruction: 'Húzd és ejtsd az ügyfeleket az ajánlói kapcsolatok frissítéséhez',
    invalidMove: 'Nem lehet egy ügyfelet saját maga vagy ajánlottjai alá mozgatni',
    filtered: 'Szűrt Találatok',
    searchPlaceholder: 'Keresés név, felhasználónév, email vagy ID alapján...',
    averageTeamSize: 'Átlagos Csapatméret',
    deepestChain: 'Leghosszabb Lánc',
    topReferrers: 'Legjobb Ajánlók',
    members: 'tag',
    removeReferrer: 'Ajánló eltávolítása',
    noReferrerFilter: 'Ajánló nélküliek',
    lastWeek: '7 nap',
    lastMonth: '30 nap',
    last3Months: '90 nap',
    allTime: 'Összes',
    removeSuccess: 'Ajánló törölve: {{username}}',
    unknownReferrer: 'Ismeretlen ajánló'
  },
  register: {
    title: 'Regisztráció',
    referredBy: 'Meghívó:',
    secure: 'Az adataid biztonságosan titkosítva vannak',
    verifyingReferral: 'Sajnáljuk, ez a meghívó kód nem létezik vagy lejárt',
    form: {
      username: 'Felhasználónév',
      email: 'Email cím',
      password: 'Jelszó',
      confirmPassword: 'Jelszó megerősítése',
      firstName: 'Keresztnév',
      lastName: 'Vezetéknév',
      submit: 'Regisztráció',
      usernameWarning: 'A felhasználónév később nem módosítható'
    },
    errors: {
      invalidReferral: 'Érvénytelen Meghívó Link',
      checkReferral: 'A használni kívánt meghívó kód érvénytelen vagy lejárt. Kérjük, ellenőrizd a linket és próbáld újra.',
      directRegistration: 'Közvetlen regisztráció nem engedélyezett',
      passwordMismatch: 'A jelszavak nem egyeznek',
      emailExists: 'Ez az email cím már regisztrálva van',
      usernameTaken: 'Ez a felhasználónév már foglalt',
      verificationFailed: 'Nem sikerült ellenőrizni a meghívót',
      registrationFailed: 'A regisztráció sikertelen. Kérjük, próbáld újra.',
      authDisabled: 'A regisztráció átmenetileg nem elérhető. Kérjük, próbáld később.',
      weakPassword: 'A jelszónak legalább 6 karakter hosszúnak kell lennie'
    }
  },
  referral: {
    title: 'Meghívó Link',
    information: 'Meghívói Információk',
    code: 'Meghívói Kód',
    link: 'Meghívó Link',
    description: 'Oszd meg a meghívó linkedet és építsd a csapatodat!',
    linkCopied: 'Link másolva!',
    copyError: 'Nem sikerült másolni a linket',
    usernameError: 'Hiba történt a felhasználónév lekérésekor',
    shareEmail: 'Megosztás emailben',
    emailSubject: 'Csatlakozz hozzám!',
    emailBody: 'Szia! Csatlakozz hozzám ezen a linken: {link}',
    whatsappMessage: 'Szia! Csatlakozz hozzám ezen a linken: {link}',
    stats: {
      totalReferrals: 'Összes meghívott',
      activeReferrals: 'Aktív meghívottak',
      totalEarnings: 'Összes jutalék'
    }
  },
  nav: {
    dashboard: 'Vezérlőpult',
    investments: 'Befektetések',
    support: 'Támogatás'
  },
  profile: {
    menu: {
      title: 'Felhasználói menü megnyitása',
      profile: 'Profil',
      signOut: 'Kijelentkezés'
    }
  },
  user: {
    dashboard: {
      title: 'Irányítópult',
      balance: {
        title: 'Egyenleg',
        available: 'Elérhető Egyenleg',
        total: 'Teljes Egyenleg',
        deposit: 'Befizetés',
        withdraw: 'Kifizetés',
        lastUpdate: 'Utolsó frissítés'
      },
      investments: {
        title: 'Befektetések',
        active: 'Aktív Befektetések',
        total: 'Összes Befektetés',
        recent: 'Legutóbbi Befektetések',
        daysLeft: 'nap van hátra',
        noActive: 'Nincs aktív befektetés',
        startNew: 'Kezdj el befektetni most',
        viewAll: 'Összes befektetés megtekintése'
      },
      profits: {
        title: 'Nyereség',
        statistics: 'Nyereség Statisztika',
        today: 'Mai',
        thisMonth: 'Ebben a Hónapban',
        total: 'Teljes Nyereség',
        totalAmount: 'Teljes Nyereség: {{amount}} NFU'
      },
      quickActions: {
        title: 'Gyors Műveletek',
        deposit: 'Befizetés',
        invest: 'Új Befektetés',
        withdraw: 'Kifizetés',
        referral: 'Barátok Meghívása'
      }
    }
  },
  projects: {
    title: 'Projektek',
    all: 'Összes projekt',
    archived: 'Archivált projektek',
    deleted: 'Törölt projektek',
    new: 'Új projekt',
    types: {
      earphone: 'Tipus FÜLÓRA',
      earphoneNft: 'FÜLÓRA NFT - Vásárlás',
      fuelNft: 'FÜLÓRA - Üzemanyag NFT',
      salaryNft: 'FÜLÓRA - Bér kifizetése NFT'
    },
    status: {
      waitingCrypto: 'Befizetést várunk - KRIPTO',
      waitingHuf: 'Díjbkérő kiküldése - HUN',
      processed: 'Feldolgozva',
      inactive: 'Inaktív',
      stakeWriting: 'Stake kiírás'
    },
    colors: {
      green: 'Zöld',
      orange: 'Narancs',
      blue: 'Kék',
      red: 'Piros'
    },
    table: {
      name: 'Projekt neve',
      customer: 'Ügyfél',
      type: 'Típus',
      status: 'Státusz',
      createdAt: 'Létrehozva',
      actions: 'Műveletek'
    },
    selectType: 'Válassz típust',
    selectStatus: 'Válassz státuszt',
    form: {
      name: 'Projekt neve',
      type: 'Típus',
      status: 'Státusz',
      customer: 'Ügyfél',
      color: 'Szín',
      notes: 'Megjegyzések',
      contractNumber: 'Szerződésszám',
      language: 'Nyelv',
      payment: {
        nftCount: 'NFT darabszám',
        splitPayment: 'Részletfizetés',
        nftValueUSDT: 'NFT érték (USDT)',
        currency: 'Pénznem',
        paymentType: 'Fizetési típus',
        paymentMethod: 'Fizetési mód',
        amount: 'Összeg'
      }
    }
  },
  login: {
    welcome: 'Üdvözöljük az Előny Klubban!',
    description: 'A név kötelez. Lépj be, az előnyök rád várnak! ',
    feature1: 'Exkluzív kedvezmények válogatott szolgáltatásokra és termékekre',
    feature2: 'Megbízható, ellenőrzött partnerektől származó ajánlatok',
    feature3: 'Folyamatosan bővülő kedvezmény kínálat'
  },
  wallet: {
    title: 'Wallet',
    all: 'Felhasználók',
    transactions: 'Tranzakciók',
    transfers: 'Utalások'
  }
}; 